import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import ToolboxItem from '../../../Prototype/UI/Level/ToolboxItem';
import { StartAnimation } from '../AnimationHelper';
import Point from '../../../Utility/Point';

export class BoosterDescriptionShow extends AnimationClip {
    public *execute(
        gameObject: ToolboxItem,
        meta?: any
    ): IterableIterator<number> {
        const duration: number = 300;
        const fadeInSettings: any = {
            duration: 100,
            startAlpha: 0,
            endAlpha: 1,
        };
        const backgroundRenderable = gameObject.descriptionSection.getComponent(
            Renderable
        );
        const backgroundElement = gameObject.descriptionSection.getComponent(
            ElementComponent
        );

        gameObject.title.getComponent(Renderable).alpha = 0;
        gameObject.description.getComponent(Renderable).alpha = 0;

        backgroundRenderable.visible = true;
        backgroundElement.scale = new Point(0, 1);

        const scaleTween = this.getTween(backgroundElement.scale);
        scaleTween
            .to({ x: 1 }, duration)
            .easing(Easing.Quadratic.Out)
            .onComplete(() => {
                StartAnimation(gameObject.title, 'Alpha', fadeInSettings);
                StartAnimation(gameObject.description, 'Alpha', fadeInSettings);
            });

        yield* this.startTween(scaleTween);
    }
}
